// PachBae Studi-OS — Input Sheet mock data
// An "input sheet" is the studio's line list for a tracking session:
// every channel coming off the floor, what mic is on it, what stand/position,
// which preamp it lands in, any inserts, and the DAW track #.

// Each ROW links into the inventory via micId / preId / insertId.
// The inventory module reads these IDs to auto-mark items "in-session".

const INPUT_SHEETS = [
  {
    id: "SHEET-MH-DAYBREAK",
    sessionId: "SES-2026-04-22-MH",
    song: "Daybreak",
    sheetKind: "song",
    songNo: 1,
    take: 14,
    bpm: 92,
    key: "G",
    duration: "4:18",
    active: true,
    rows: [
      { ch: 1,  source: "Kick In",     pos: "Inside, off batter",      micId: "MIC-012", stand: "Low boom",  phantom: false, pad: false, hpf: false, preId: "PRE-003", gain: 38, insertId: "OUT-001", daw: 1,  notes: "Push for chorus" },
      { ch: 2,  source: "Kick Sub",    pos: "Tunnel",                  micId: "—",       stand: "Floor",     phantom: false, pad: false, hpf: false, preId: "PRE-003", gain: 32, insertId: null,      daw: 2,  notes: "Yamaha SubKick" },
      { ch: 3,  source: "Snare Top",   pos: "1\" off rim, 45°",        micId: "MIC-011", stand: "Goose",     phantom: false, pad: false, hpf: true,  preId: "PRE-001", gain: 42, insertId: null,      daw: 3,  notes: "" },
      { ch: 4,  source: "Snare Btm",   pos: "Underneath, snare wires", micId: "—",       stand: "Goose",     phantom: false, pad: false, hpf: true,  preId: "PRE-001", gain: 44, insertId: null,      daw: 4,  notes: "Phase inverted" },
      { ch: 5,  source: "Hi-Hat",      pos: "8\" above edge",          micId: "MIC-005", stand: "Boom",      phantom: true,  pad: false, hpf: true,  preId: "PRE-002", gain: 30, insertId: null,      daw: 5,  notes: "" },
      { ch: 6,  source: "Rack Tom",    pos: "Rim, 2\" off head",       micId: "MIC-010", stand: "Clip",      phantom: false, pad: false, hpf: false, preId: "PRE-003", gain: 36, insertId: null,      daw: 6,  notes: "" },
      { ch: 7,  source: "Floor Tom",   pos: "Rim, 2\" off head",       micId: "—",       stand: "Clip",      phantom: false, pad: false, hpf: false, preId: "PRE-003", gain: 36, insertId: null,      daw: 7,  notes: "Sennheiser e604" },
      { ch: 8,  source: "Overhead L",  pos: "XY pair, 4' above",       micId: "MIC-007", stand: "Tall boom", phantom: false, pad: false, hpf: false, preId: "PRE-003", gain: 40, insertId: null,      daw: 8,  notes: "Coles pair" },
      { ch: 9,  source: "Overhead R",  pos: "XY pair, 4' above",       micId: "—",       stand: "Tall boom", phantom: false, pad: false, hpf: false, preId: "PRE-003", gain: 40, insertId: null,      daw: 9,  notes: "(2nd Coles 4038)" },
      { ch: 10, source: "Room Mono",   pos: "8' high, far wall",       micId: "MIC-004", stand: "Boom",      phantom: true,  pad: true,  hpf: false, preId: "PRE-004", gain: 28, insertId: null,      daw: 10, notes: "U87 omni" },
      { ch: 11, source: "Bass DI",     pos: "Pre-amp out",             micId: "DI-002",  stand: "Floor",     phantom: false, pad: false, hpf: false, preId: "PRE-004", gain: 26, insertId: "OUT-002", daw: 11, notes: "Avalon U5" },
      { ch: 12, source: "Bass Cab",    pos: "Dust cap, 2\"",           micId: "—",       stand: "Short",     phantom: false, pad: false, hpf: false, preId: "PRE-003", gain: 32, insertId: null,      daw: 12, notes: "RE20 borrowed" },
      { ch: 13, source: "Ac. Guitar",  pos: "12th fret, 8\"",          micId: "MIC-003", stand: "Boom",      phantom: true,  pad: false, hpf: true,  preId: "PRE-003", gain: 34, insertId: null,      daw: 13, notes: "Martin D-28" },
      { ch: 14, source: "E. Guitar",   pos: "Edge of cone, 1\"",       micId: "—",       stand: "Low",       phantom: false, pad: false, hpf: false, preId: "PRE-001", gain: 28, insertId: null,      daw: 14, notes: "57 + 121 blend" },
      { ch: 15, source: "Piano Lo",    pos: "Hammers, low",            micId: "—",       stand: "Boom",      phantom: true,  pad: false, hpf: true,  preId: "PRE-002", gain: 32, insertId: null,      daw: 15, notes: "Steinway B" },
      { ch: 16, source: "Piano Hi",    pos: "Hammers, high",           micId: "—",       stand: "Boom",      phantom: true,  pad: false, hpf: true,  preId: "PRE-002", gain: 32, insertId: null,      daw: 16, notes: "" },
      { ch: 17, source: "Lead Vox",    pos: "Pop filter, 4\"",         micId: "MIC-001", stand: "Tall",      phantom: false, pad: false, hpf: true,  preId: "PRE-003", gain: 36, insertId: null,      daw: 17, notes: "U47 — handle w/ care" },
      { ch: 18, source: "BG Vox",      pos: "Talent room",             micId: "MIC-002", stand: "Tall",      phantom: false, pad: false, hpf: true,  preId: "PRE-003", gain: 34, insertId: null,      daw: 18, notes: "251 — Marlowe + Jaye" },
      { ch: 19, source: "Talkback",    pos: "CR desk",                 micId: "—",       stand: "—",         phantom: false, pad: false, hpf: false, preId: "—",       gain: 0,  insertId: null,      daw: null, notes: "" },
      { ch: 20, source: "Click",       pos: "DAW bus",                 micId: "—",       stand: "—",         phantom: false, pad: false, hpf: false, preId: "—",       gain: 0,  insertId: null,      daw: 32, notes: "92 BPM, side 1/4 muted" },
    ],
  },
  {
    id: "SHEET-MH-HELIOTROPE",
    sessionId: "SES-2026-04-22-MH",
    song: "Heliotrope",
    sheetKind: "song",
    songNo: 2,
    take: 6,
    bpm: 76,
    key: "Dm",
    duration: "5:02",
    active: false,
    rows: [],
  },
  {
    id: "SHEET-MH-WALKHOME",
    sessionId: "SES-2026-04-22-MH",
    song: "Walk Home Slow",
    sheetKind: "song",
    songNo: 3,
    take: 0,
    bpm: 68,
    key: "C",
    duration: "—",
    active: false,
    rows: [],
  },
  {
    id: "SHEET-MH-CHECK",
    sessionId: "SES-2026-04-22-MH",
    song: "Line check",
    sheetKind: "linecheck",
    songNo: 0,
    take: 0,
    bpm: null,
    key: null,
    duration: "—",
    active: false,
    rows: [],
    isCheck: true,
  },
];

const SESSIONS_OPEN = [
  {
    id: "SES-2026-04-22-MH",
    artist: "Marlowe Hayes",
    project: "Album — Working title: \"Carry The Light\"",
    label: "Saddle Creek",
    room: "Studio A",
    engineer: "Jonah Castellanos",
    assistant: "Rae Okafor",
    producer: "Ana Velasquez",
    startDate: "Apr 19, 2026",
    day: 3,
    dayOf: 6,
    headphoneMix: "HP-A · 6 mixes",
    sampleRate: "96 kHz / 24-bit",
    daw: "Pro Tools Ultimate 2025.12",
    console: "Neve 8068 MkII",
    active: true,
  },
  {
    id: "SES-2026-04-22-BR",
    artist: "Brass overdub — Friend of the Pod",
    project: "Single — \"Carbon Copy\"",
    room: "Studio B",
    engineer: "Diane Park",
    startDate: "Apr 22, 2026",
    day: 1, dayOf: 1,
    sampleRate: "48 kHz / 24-bit",
    active: false,
  },
];

Object.assign(window, { INPUT_SHEETS, SESSIONS_OPEN });
